var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"page-wrapper sidebar",class:{toggled: _vm.isActive},attrs:{"id":"mainSidebar"}},[_c('Quicksearch'),_c('Nav',{ref:"nav"}),_c('Map',{ref:"map"}),(true)?_c('AppLoading'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }